 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		11: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"200450fc5b1a0fe10e4c681dafd61bca37817501","2":"edf3535aced653b0e178639fa7f04ee143795c54","3":"48fd66a7b8563289ea94669bc022bb0d150ec79b","4":"7ba1e46e1cb5d2ed68dabe5ad1d72bd99ca4e73b","5":"8df789f331b9eb062f63d294888cb12797ef70fb","6":"c05b8182","7":"component---src-pages-layout-js","8":"f68b6560540997019da160705c016bf18f9f73c7","9":"9792b413b5a274ce46bf46d519555576faa75f82","10":"component---src-pages-integration-builder-sections-code-tsx","12":"11e8d57d","14":"5cf42e9e","15":"5d19cfc4","16":"962beaf7","18":"component---src-pages-404-js","19":"component---src-pages-banner-js","20":"component---src-pages-classic-home-js","21":"component---src-pages-docs-template-js","22":"component---src-pages-home-js","23":"component---src-pages-index-js","24":"component---src-pages-integration-builder-index-tsx","25":"component---src-pages-integration-builder-sections-build-tsx","26":"component---src-pages-integration-builder-sections-card-generator-tsx","27":"component---src-pages-integration-builder-sections-configure-tsx","28":"component---src-pages-integration-builder-sections-demo-tsx","29":"component---src-pages-integration-builder-sections-help-modal-tsx","30":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","31":"component---src-pages-integration-builder-sections-preview-tsx","32":"component---src-pages-integration-builder-sections-take-live-tsx","33":"component---src-pages-internal-js","34":"component---src-pages-signup-js","35":"component---src-pages-signupauto-js","36":"component---src-pages-support-js","37":"component---src-pages-thankyou-js","38":"component---src-pages-unsubscribe-js","39":"component---src-templates-template-layout-js","40":"d7eeaac4"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"a20e9775fd6710d8e205","2":"ee3367227e602f44b8a8","3":"104e309ac120c3808e52","4":"3c0e919a44f208b1928a","5":"20f01a670742e2267e7f","6":"3f37f64ca4777772499e","7":"372a8b6d85daa7c2e91c","8":"7cd1e3464c069969dada","9":"17b0a21bcc1331e54e02","10":"c70d4eb3392555d2595d","12":"daa9b0dc68442b40b590","14":"6cceaba3d51f1bc5c299","15":"719ad85cf8c014dccc75","16":"82b52d358e31873f0de0","18":"f0cad4d3c0521ab6c8ee","19":"4f219ad5ed2de49b3a3d","20":"e90ad8a6988b9c040db4","21":"6155a8207bcb0525ad8d","22":"20ded64d9a7e461f321d","23":"ec00a82673d726aa32ca","24":"958389595c479a721044","25":"5953d57af322826eca9d","26":"f090f1ea59f30bcb3b75","27":"726f14620355a2cb4723","28":"cf2e02812935f92afc4a","29":"5827e67119effa368f9d","30":"c865a424510f24264724","31":"4327365b9d12221f55bb","32":"a9a47018a31589e87650","33":"616af65b406d85550001","34":"89fca8480f4b122bed18","35":"2cd891101fc0eac8e32b","36":"633363f38fc35bd695ce","37":"7c2b3d8cafa64bfcadfe","38":"0e2630a2c2cd0b5b0125","39":"9548f031efda86f59270","40":"f98171499d6dc2b9c6c2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"200450fc5b1a0fe10e4c681dafd61bca37817501","2":"edf3535aced653b0e178639fa7f04ee143795c54","3":"48fd66a7b8563289ea94669bc022bb0d150ec79b","4":"7ba1e46e1cb5d2ed68dabe5ad1d72bd99ca4e73b","5":"8df789f331b9eb062f63d294888cb12797ef70fb","6":"c05b8182","7":"component---src-pages-layout-js","8":"f68b6560540997019da160705c016bf18f9f73c7","9":"9792b413b5a274ce46bf46d519555576faa75f82","10":"component---src-pages-integration-builder-sections-code-tsx","12":"11e8d57d","14":"5cf42e9e","15":"5d19cfc4","16":"962beaf7","18":"component---src-pages-404-js","19":"component---src-pages-banner-js","20":"component---src-pages-classic-home-js","21":"component---src-pages-docs-template-js","22":"component---src-pages-home-js","23":"component---src-pages-index-js","24":"component---src-pages-integration-builder-index-tsx","25":"component---src-pages-integration-builder-sections-build-tsx","26":"component---src-pages-integration-builder-sections-card-generator-tsx","27":"component---src-pages-integration-builder-sections-configure-tsx","28":"component---src-pages-integration-builder-sections-demo-tsx","29":"component---src-pages-integration-builder-sections-help-modal-tsx","30":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","31":"component---src-pages-integration-builder-sections-preview-tsx","32":"component---src-pages-integration-builder-sections-take-live-tsx","33":"component---src-pages-internal-js","34":"component---src-pages-signup-js","35":"component---src-pages-signupauto-js","36":"component---src-pages-support-js","37":"component---src-pages-thankyou-js","38":"component---src-pages-unsubscribe-js","39":"component---src-templates-template-layout-js","40":"d7eeaac4"}[chunkId]||chunkId) + "." + {"0":"99747e602a568bbba8db","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.paypalobjects.com/ppdevdocs/v2noapi/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
